// @ts-nocheck
import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { SkeletonCard, SkeletonWrapper, SkeletonLoad } from './Skeleton.style';
import { COLORS } from '../../styles/variables';

const SkeletonLoader: React.FC = () => {
  return (
    <SkeletonCard data-testid="skeleton-loader">
      <SkeletonTheme color={COLORS.skeletonColor} highlightColor={COLORS.highlightColor}>
        <SkeletonWrapper>
          <SkeletonLoad className="status" />
          <SkeletonLoad className="name" />
          <SkeletonLoad className="location" />
          <SkeletonLoad className="image" />
          <SkeletonLoad className="price" />
        </SkeletonWrapper>
      </SkeletonTheme>
    </SkeletonCard>
  );
};

export default SkeletonLoader;
